// extracted by mini-css-extract-plugin
module.exports = {"contentContainer":"NoComments_contentContainer__If3ZL"};